import modules from '@/sui/data/modules'
import denominators from '@/sui/data/sheets/convert/denominators'
import toolsUsage from '@/sui/data/sheets/convert/toolsUsage'
import convert from '@/sui/data/sheets/convert/convert'

function getFields (type, year, errors) {
  let obj = null
  if (type === 'denominators') {
    obj = denominators(`${year}`)
  } else if (type === 'toolsUsage') {
    obj = toolsUsage[`${year}`]
  } else {
    const module = modules[year][type]
    if (module != null) {
      obj = module.sheets.convert
    }
  }

  if (obj == null) {
    errors.push(`Invalid type : ${type}.`)
    return null
  }

  return [
    { field: 't', cfield: 'type' },
    { field: 'id' },
    { field: 'v' },
    { field: 'y', cfield: 'year', special: 'numeric' },
    { field: 'f', object: obj }
  ]
}

export default {
  serverToClient: function (sheet) {
    const result = {
      sheet: {},
      errors: []
    }
    const fields = getFields(sheet.t, sheet.y, result.errors)
    if (fields != null) {
      convert.serverToClient(result.sheet, sheet, result.errors, fields)
    }
    return result
  },

  clientToServer: function (sheet) {
    const result = {
      sheet: {},
      errors: []
    }
    const fields = getFields(sheet.type, sheet.year, result.errors)
    if (fields != null) {
      convert.clientToServer(sheet, result.sheet, result.errors, fields)
    }

    return result
  }
}
